/**
 * A page header steps aside for the closed menu's corner controls — on a phone, and where the
 * menu closes away (settings). Closed to the rail on a desktop, the rail holds them.
 */
export const COLLAPSED_SIDEBAR_TITLEBAR_INSET_CLASS =
  "[[data-sidebar-state=collapsed]:not([data-sidebar-rail])_&]:pl-[var(--workspace-titlebar-content-left)] max-md:[[data-sidebar-state=collapsed]_&]:pl-[var(--workspace-titlebar-content-left)] max-md:[[data-sidebar-state=expanded]_&]:pl-[var(--workspace-titlebar-content-left)]";
